<valg-table
[columnDefinition]="coalitionListColumnDef"
[data]="data"
[itemName]="'coalition_list.item_name' | translate"
[title]="'coalition_list.title' | translate"
[hasPagination]="false"
[displayItemCount]="false"
[hasMainActionButton]="false">
    <h2 class="m-0 text--f20 text--500">{{ 'coalition_list.title' | translate }}</h2>
</valg-table>